import React from "react";
import { productDetailsSpecs } from "../redux/actions";
import { useCallback, useState, useEffect } from "react";

const ShippingTwo = () => {
  const [specsData, setSpecsData] = useState({});

  const productDetailsSpec = useCallback(async () => {
    const data = await productDetailsSpecs();

    if (data?.page?.data?.en) {
      setSpecsData(data?.page?.data?.en);
    }
  }, []);

  useEffect(() => {
    productDetailsSpec();
  }, [productDetailsSpec]);

  //console.log(specsData);
  return (
    <section className="shipping mb-80" id="shipping">
      <div className="container container-lg">
        <div className="row gy-4">
          {specsData?.values?.length > 0 &&
            specsData?.values.map((value, index) => (
              <div key={index} className="col-xxl-3 col-sm-6 d-flex">
                <div className="shipping-item flex-align gap-16 rounded-16 bg-main-product-50 transition-2 w-100 h-100">
                  <span className="w-56 h-56 flex-center rounded-circle bg-main-two-600 text-white text-32 flex-shrink-0">
                    <i className={value?.attributes?.icon} />
                  </span>
                  <div className="d-flex flex-column justify-content-between">
                    <h6 className="mb-0 text-white">
                      {value?.attributes?.title}
                    </h6>
                    <span
                      className="text-sm text-white"
                      style={{ minHeight: "3.5em", lineHeight: "1.75em" }}
                    >
                      {value?.attributes?.description}
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default ShippingTwo;
